import { el } from 'redom';

import serverInterface from 'server-interface';

import TextInput from 'generics/components/text-input';
import IconButton from 'generics/components/icon-button';

import { stringToSVG } from 'utilities';

import HelptapEditor from '../../../../../helpers';

import refreshIconString from 'assets/images/refresh-icon.svg?raw';

import './index.scss';

const refreshIcon = stringToSVG(refreshIconString);

class RowsInputPanel {

  constructor(configuration) {

    this.editor = configuration.editor;
    this.node = configuration.node;
    this.activeNodePath = configuration.activeNodePath;
    this.menu = configuration.menu;
    this.parentEntityId = configuration.parentEntityId;

    this.rowsInput = new TextInput({
      placeholder: 'Rows count',
      type: 'number',
      attributes: {
        min: 1
      },
      value: this.node.properties.rowsCount,
      onChange: this.handleRowsCountChange.bind(this)
    });

    this.applyButton = new IconButton({
      class: 'apply-data-collection-rows-count-button application-button round-button button-with-stroke-svg',
      icon: refreshIcon,
      onClick: this.handleRefreshButtonClick.bind(this)
    });

    this.applyButton.setReadOnly(this.determineButtonDisabledStatus());

    this.el = el('.data-collection-rows-input-panel-main', [
      el('label.side-value-control-label.field-label', 'Database records to display'),
      el('.data-collection-rows-input-controls', [
        this.rowsInput,
        el('x-tooltip', { text: 'Apply records count' }, [this.applyButton])
      ])
    ]);

  }

  determineButtonDisabledStatus() {

    if (+this.rowsInput.getValue() === this.node.properties.rowsCount) {
      return true;
    }

    if (this.rowsInput.el.validity.valid === false) {
      return true;
    }

    return false;

  }

  handleRowsCountChange() {

    this.applyButton.setReadOnly(this.determineButtonDisabledStatus());

  }

  async tryUpdateManagerRowsCount(rowsCount) {

    const page = await serverInterface.startup.pages.getPopulatedPageById(this.parentEntityId, ['managerRoot', 'managerId']);

    if (page.managerRoot !== true) {
      return;
    }

    await serverInterface.startup.pagesManagers.updatePagesManagerRowsCountById(page.managerId, {
      rowsCount
    });

  }

  async handleRefreshButtonClick() {

    const rowsCount = +this.rowsInput.getValue();
    const properties = this.node.properties;
    const collectionId = properties.collectionId;
    const filterId = properties.filterId;

    this.tryUpdateManagerRowsCount(rowsCount);

    const rows = await serverInterface.startup.pages.getRecordsForPageAndDataCollectionNode(this.parentEntityId, {
      ...this.node,
      properties: {
        ...this.node.properties,
        rowsCount
      }
    });

    HelptapEditor.dataCollection.updateRows(this.editor, this.node, this.activeNodePath, rowsCount, rows);

  }

  update(configuration) {
    this.editor = configuration.editor;
    this.node = configuration.node;
    this.activeNodePath = configuration.activeNodePath;
  }

}

export default RowsInputPanel;